<form
  (ngSubmit)="onSubmit()"
  [formGroup]="loginForm"
  [ngClass]="{ dialog: dialog }"
  *ngIf="auction$ | async as auction"
>
  <div class="form-container">
    <mat-form-field class="form-field" *ngIf="isMobileType; else email">
      <mat-label [translate]="getIdentityInputLabel()"></mat-label>
      <gb-intl-phone-input
        formControlName="identity"
        [auctionCountryCode]="auction.country"
        name="identity"
        [allowNonNumeric]="true"
        [focusInput]="true"
      >
      </gb-intl-phone-input>
      <mat-icon matSuffix>person</mat-icon>
      <mat-error translate="AUTH.LOGIN.INPUT_LABEL_INVALID" *ngIf="!identityControl.valid"></mat-error>
    </mat-form-field>

    <ng-template #email>
      <mat-form-field class="form-field">
        <mat-label [translate]="getIdentityInputLabel()"></mat-label>
        <input
          matInput
          required
          formControlName="identity"
          name="identity"
          autocomplete="username"
          #matInput="matInput"
          type="email"
        />
        <mat-icon matSuffix>person</mat-icon>
        <mat-error translate="AUTH.LOGIN.INPUT_LABEL_INVALID" *ngIf="!identityControl.valid"></mat-error>
      </mat-form-field>
    </ng-template>

    <mat-form-field class="form-field">
      <mat-label translate="AUTH.PASSWORD_INPUT_LABEL"></mat-label>
      <input
        matInput
        required
        formControlName="password"
        name="password"
        type="password"
        autocomplete="current-password"
      />
      <mat-icon matSuffix>lock</mat-icon>
    </mat-form-field>

    <div class="flex-row flex-wrap flex-fill flex-justify-end flex-align-center">
      <button
        mat-raised-button
        color="primary"
        class="full-width-button"
        [disabled]="loginForm.invalid"
        type="submit"
        translate="AUTH.LOGIN_BUTTON"
      ></button>
    </div>
  </div>
</form>
